import { render, staticRenderFns } from "./Dressing.vue?vue&type=template&id=7ef940b1&"
import script from "./Dressing.vue?vue&type=script&lang=js&"
export * from "./Dressing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports